export var MandatoryDocumentStatus;
(function (MandatoryDocumentStatus) {
    MandatoryDocumentStatus["Missing"] = "missing";
    MandatoryDocumentStatus["Uploaded"] = "uploaded";
    MandatoryDocumentStatus["Pending"] = "pending";
    MandatoryDocumentStatus["Invalid"] = "invalid";
    MandatoryDocumentStatus["Valid"] = "valid";
    MandatoryDocumentStatus["NotVerified"] = "not_verified";
})(MandatoryDocumentStatus || (MandatoryDocumentStatus = {}));
